import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap } from '@ngrx/store';
import * as fromAnalysis from './analysis-store/reducers/analysis.reducer';
import * as fromAuth from './auth-store/reducers/auth.reducer';
import * as fromHorses from './horses-store/reducers/horses.reducer';
import * as fromUser from './user-store/reducers/user.reducer';
import {
  logoutUserSuccess,
  loginUser,
} from './auth-store/actions/auth.actions';

export interface State {
  auth: fromAuth.State;
  user: fromUser.State;
  horses: fromHorses.State;
  analysis: fromAnalysis.State;
  router: RouterReducerState<any>;
}

export const reducers: ActionReducerMap<State> = {
  auth: fromAuth.reducer,
  user: fromUser.reducer,
  horses: fromHorses.reducer,
  analysis: fromAnalysis.reducer,
  router: routerReducer,
};

export function clearState(
  reducer: ActionReducer<State>,
): ActionReducer<State> {
  return (state, action) => {
    if (
      action != null &&
      (action.type === logoutUserSuccess.type || action.type === loginUser.type)
    ) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}
